import axiosInstance from './AxiosInstance';

/**
 * Obtiene todos los tags ordenados alfabéticamente
 * GET /tags?tipo={tipo}
 * @param {string} tipo - (Opcional) Tipo de tag para filtrar
 */
export function getAllTags(tipo = null) {
    const params = {};
    if (tipo) {
        params.tipo = tipo;
    }
    return axiosInstance.get('/tags', { params });
}

/**
 * Obtiene un tag por ID
 * GET /tags/{id}
 * @param {string} id - ID del tag (UUID)
 */
export function getTagById(id) {
    return axiosInstance.get(`/tags/${id}`);
}

/**
 * Crea un nuevo tag
 * POST /tags
 * @param {Object} tagData - Datos del tag
 * @param {string} tagData.nombre - Nombre del tag
 * @param {string} tagData.tipo - Tipo del tag (TagTipo)
 */
export function createTag(tagData) {
    return axiosInstance.post('/tags', tagData);
}

/**
 * Busca un tag por nombre y tipo, si no existe lo crea
 * Primero busca en la lista de tags, si no existe crea uno nuevo
 * @param {string} nombre - Nombre del tag
 * @param {string} tipo - Tipo del tag (vacante o resume)
 */
export async function findOrCreateTag(nombre, tipo) {
    // Primero obtener todos los tags del tipo especificado
    const response = await getAllTags(tipo);
    const tags = response.data;
    
    // Buscar si ya existe un tag con ese nombre y tipo
    const existingTag = tags.find(
        tag => tag.nombre.toLowerCase() === nombre.toLowerCase() && tag.tipo === tipo
    );
    
    if (existingTag) {
        return { data: existingTag };
    }
    
    // Si no existe, crear uno nuevo
    return await createTag({ nombre: nombre.trim(), tipo });
}

/**
 * Actualiza un tag
 * PATCH /tags/{id}
 * @param {string} id - ID del tag (UUID)
 * @param {Object} tagData - Datos a actualizar
 */
export function updateTag(id, tagData) {
    return axiosInstance.patch(`/tags/${id}`, tagData);
}

/**
 * Elimina un tag
 * DELETE /tags/{id}
 * @param {string} id - ID del tag (UUID)
 */
export function deleteTag(id) {
    return axiosInstance.delete(`/tags/${id}`);
}

